import {push} from "connected-react-router";
import {get, post} from '../utils/api';
import http from '../utils/api';
import {fetchSearchData, fetchSearchBegin} from "./searchActions";

export const CREATE_CAMPAIGN_BEGIN = 'CREATE_CAMPAIGN_BEGIN';
export const FETCH_CAMPAIGN_BEGIN = 'FETCH_CAMPAIGN_BEGIN';
export const FETCH_CAMPAIGN_SUCCESS = 'FETCH_CAMPAIGN_SUCCESS';
export const DELETE_CAMPAIGN_BEGIN = 'DELETE_CAMPAIGN_BEGIN';
export const DELETE_CAMPAIGN_SUCCESS = 'DELETE_CAMPAIGN_SUCCESS';
export const CREATE_CAMPAIGN_FAILURE = 'CREATE_CAMPAIGN_FAILURE';
export const UPDATE_CAMPAIGN_FAILURE = 'UPDATE_CAMPAIGN_FAILURE';
export const UPDATE_CAMPAIGN_SUCCESS = 'UPDATE_CAMPAIGN_SUCCESS';
export const UPDATE_CAMPAIGN_BEGIN = 'UPDATE_CAMPAIGN_BEGIN';
export const SORT_CAMPAIGN = 'SORT_CAMPAIGN';
export const UPDATE_CAMPAIGN_SORT = 'UPDATE_CAMPAIGN_SORT';

export const PUBLISH_TO_JIRA = 'PUBLISH_TO_JIRA';
export const PUBLISH_TO_JIRA_SUCCESS = 'PUBLISH_TO_JIRA_SUCCESS'
export const SET_SELLER_INACTIVE_BEGIN = 'SET_SELLER_INACTIVE_BEGIN';
export const SET_SELLER_INACTIVE_SUCCESS = 'SET_SELLER_INACTIVE_SUCCESS';
export const DELETE_SELLER_BEGIN = 'DELETE_SELLER_BEGIN';
export const DELETE_SELLER_SUCCESS = 'DELETE_SELLER_SUCCESS';
export const FETCH_CAMPAIGN_META_SUCCESS = 'FETCH_CAMPAIGN_META_SUCCESS';

export const fetchCampaignBegin = () => ({
    type: FETCH_CAMPAIGN_BEGIN
});
export const fetchCampaignSuccess = result => ({
    type: FETCH_CAMPAIGN_SUCCESS,
    payload: result
});

export const deleteCampaignBegin = () => ({
    type: DELETE_CAMPAIGN_BEGIN
});

export const deleteCampaignSuccess = () => ({
    type: DELETE_CAMPAIGN_SUCCESS
});

export const createCampaignBegin = () => ({
    type: CREATE_CAMPAIGN_BEGIN
});
export const publishToJiraSuccess = (result) => ({
    type: PUBLISH_TO_JIRA_SUCCESS,
    payload: result
})
export const publishToJiraBEGIN = () => ({
    type: PUBLISH_TO_JIRA
})
export const createCampaignFailure = () => ({
    type: CREATE_CAMPAIGN_FAILURE
});

export const updateCampaignBegin = () => ({
    type: UPDATE_CAMPAIGN_BEGIN
});

export const createCampaignSuccess = () => ({
    type: UPDATE_CAMPAIGN_SUCCESS
});

export const updateCampaignFailure = () => ({
    type: UPDATE_CAMPAIGN_FAILURE
});

export const updateCampaignSort = (column, direction) => ({
    type: UPDATE_CAMPAIGN_SORT,
    payload: {
        sort_col: column,
        sort_dir: direction
    }
});


export const setSellerBegin = () => ({
    type: SET_SELLER_INACTIVE_BEGIN
});

export const setSellerSuccess = () => ({
    type: SET_SELLER_INACTIVE_SUCCESS
});
export const deleteSellerBegin = () => ({
    type: DELETE_SELLER_BEGIN
});

export const deleteSellerSuccess = () => ({
    type: DELETE_SELLER_SUCCESS
});
export const getCreativeInfoSuccess = result => ({
    type: FETCH_CAMPAIGN_META_SUCCESS,
    payload: result
});

export function fetchCampaign(id) {
    return (dispatch, getState) => {
        let state = getState();
        let url = '/campaigns/' + id;
        let col = state.campaign.sort_col;
        let dir = state.campaign.sort_dir;

        if (col && dir) {
            url += '?sort_col=' + col + '&sort_dir=' + dir;
        }

        dispatch(fetchCampaignBegin());
        return get(url).then((res) => {
            dispatch(fetchCampaignSuccess(res));
        });
    };
}
export function publishToJira(id){
    let url = 'campaigns/jira/' + id;
    return dispatch => {
        dispatch(publishToJiraBEGIN());
        return get(url).then((res) => {
            dispatch(publishToJiraSuccess(res));
        });
    }
}

export function createCampaign(data) {
    return dispatch => {
        dispatch(createCampaignBegin());
        return post('campaigns', data)
            .then((res) => {
                dispatch(fetchSearchData());
                return res;
            }, function (res) {
                throw res;
            }).catch(err => {
                dispatch(createCampaignFailure(err));
                throw err.response.data;
            });
    };
}

export function updateCampaign(id, data) {
    return dispatch => {
        dispatch(updateCampaignBegin());
        return post('campaigns/' + id, data)
            .then((res) => {
                dispatch(fetchCampaign(id));
                dispatch(fetchSearchData());
                return res;
            }, function (res) {
                throw res;
            }).catch(err => {
                dispatch(updateCampaignFailure(err));
                throw err.response.data;
            });
    };
}

export function deleteCampaign(id) {
    return dispatch => {
        dispatch(deleteCampaignBegin());
        return http.delete('campaigns/' + id)
            .then(res => {
                dispatch(deleteCampaignSuccess());
                dispatch(fetchSearchData());
                if (res.data.message === 'success') {
                    dispatch(push('/'))
                }
            });
    };
}
export function deleteEmptyCampaign(id) {
    return dispatch => {
        return new Promise((resolve, reject) => {
        dispatch(deleteCampaignBegin());
        return http.delete('campaigns/' + id)
            .then(res => {
                dispatch(deleteCampaignSuccess());
                dispatch(fetchSearchData());
                resolve()
            });
        })
    };
}
export function setSeller(id) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(setSellerBegin());
            return post('manage/sellers/' + id)
                .then(res => {
                    dispatch(setSellerSuccess());
                    dispatch(fetchSearchData());
                    resolve()
                });
          })
    };
}
export function deleteSeller(id) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(deleteSellerBegin());
            return http.delete('manage/sellers/' + id)
                .then(res => {
                    dispatch(deleteSellerSuccess());
                    dispatch(fetchSearchData());
                    resolve()
                });
            })
    };
}
export function getCreativeInfo(){
    return dispatch => {
        return new Promise((resolve, reject) => {
            return http.get('campaigns/meta')
                .then(res => {
                    dispatch(getCreativeInfoSuccess(res.data));
                    resolve()
                });
        })
    }
}
